import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-[#87CEEB] sticky top-0 z-40 shadow-sm">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center gap-3">
            <Link to="/" className="text-white hover:text-white/80">
              <ArrowLeft className="w-5 h-5" />
            </Link>
            <h1 className="text-lg font-semibold text-white">Terms of Service</h1>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8 max-w-3xl">
        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm">
          <h1 className="text-3xl font-bold text-slate-900 mb-2">Terms of Service</h1>
          <p className="text-slate-500 mb-8">Last updated: December 2024</p>

          <div className="prose prose-slate max-w-none">
            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">1. Acceptance of Terms</h2>
            <p className="text-slate-600 mb-4">
              By accessing and using BTR Health ("the Service"), you agree to be bound by these Terms of Service. 
              If you do not agree to these terms, please do not use our Service.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">2. Description of Service</h2>
            <p className="text-slate-600 mb-4">
              BTR Health is a platform that connects NDIS participants with support workers. We facilitate 
              the discovery, booking, and communication between participants and support workers but are not 
              directly responsible for the services provided by support workers.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">3. User Accounts</h2>
            <p className="text-slate-600 mb-4">
              To use certain features of the Service, you must register for an account. You agree to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Notify us immediately of any unauthorized access</li>
              <li>Be responsible for all activities under your account</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">4. NDIS Participants</h2>
            <p className="text-slate-600 mb-4">
              If you are an NDIS participant using our Service:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>You confirm that you are a registered NDIS participant</li>
              <li>You agree to use the Service in accordance with your NDIS plan</li>
              <li>You understand that BTR Health does not provide disability support services directly</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">5. Support Workers</h2>
            <p className="text-slate-600 mb-4">
              If you are a support worker using our Service:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>You confirm that you hold all necessary qualifications and clearances</li>
              <li>You agree to provide services professionally and ethically</li>
              <li>You are responsible for maintaining your own insurance and registrations</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">6. Bookings and Payments</h2>
            <p className="text-slate-600 mb-4">
              All bookings made through the Service are subject to availability. Payment processing is 
              handled by our secure payment provider. Cancellation policies may vary by service type.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">7. Limitation of Liability</h2>
            <p className="text-slate-600 mb-4">
              BTR Health is a platform that connects users and is not liable for:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>The quality of services provided by support workers</li>
              <li>Any disputes between participants and support workers</li>
              <li>Any damages arising from the use of our Service</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">8. Changes to Terms</h2>
            <p className="text-slate-600 mb-4">
              We reserve the right to modify these terms at any time. Continued use of the Service 
              after changes constitutes acceptance of the modified terms.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">9. Contact Us</h2>
            <p className="text-slate-600 mb-4">
              If you have any questions about these Terms, please contact us at{" "}
              <a href="mailto:support@btrhealth.com" className="text-[#87CEEB] hover:underline">
                support@btrhealth.com
              </a>
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
